module.exports = __webpack_public_path__ + "static/ME-44168531800d981906e4c607bbbaad71.svg";